import { render, staticRenderFns } from "./MainMenuPhone.vue?vue&type=template&id=493a68e8"
import script from "./MainMenuPhone.vue?vue&type=script&lang=js"
export * from "./MainMenuPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports